import { useLocalStorage } from '../../services/hooks/useLocalStorage';
import { useTranslation } from 'react-i18next';

import Header from '../Header';
import Loading from '../Loading';

const Unlicensed = () => {
    const [stratus] = useLocalStorage("stratus", false);
    const ns = stratus ? 'stratus' : 'scantrip';
    const { t } = useTranslation(ns);
    return (
        <>
        <Header />
            <Loading
                hideIcon={true}
                text={t('unlicensed')}
            />
        </>
    );
}


export default Unlicensed